import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MatchService} from '../../../shared/services/match.service';
import {empty} from '../../../functions';
import {catchError} from 'rxjs/operators';
import {AdminService} from '../../../shared/services/admin.service';

@Component({
    selector: 'app-modal-admin-matchtest-question',
    templateUrl: './modal-admin-matchtest-question.component.html',
    styleUrls: ['./modal-admin-matchtest-question.component.scss'],
    standalone: false
})
export class ModalAdminMatchtestQuestionComponent implements OnInit {

  public data:any;

  public entity = {
    id: '',
    competencyId: '',
    question: '',
    answer1: '',
    answer2: '',
    answer3: '',
    answer4: '',
    answer5: '',

  }

  public competencies:any = [];

  /**
   * Constructor
   *
   * @param activeModel
   */
  constructor(public activeModal: NgbActiveModal,
              public matchService: MatchService,
              public adminService: AdminService) {


  }

  ngOnInit(): void {

    this.entity = Object.assign({}, this.data.entity);

    this.matchService.apiGetMatchtestCompetencies().pipe(catchError(this.adminService.handleError('apiGetMatchtestCompetencies', false))).subscribe( (result:any) => {
      if (result !== false) {

        this.competencies = Object.assign([], result.data);

      }
    });
  }



  /**
   * Save
   *
   * @constructor
   */
  Save() {

    if (!empty(this.entity.id)) {

      // Update company profile
      this.matchService.apiUpdateMatchtestQuestion(this.entity.id, this.entity).subscribe( (result) => {

        this.activeModal.close(true);

      });
    } else {
      const { id, ...body } = this.entity;
      this.matchService.apiAddMatchtestQuestion(body).subscribe( (result) => {

        this.activeModal.close(true);

      });
    }

  }

}
